// @ts-nocheck



import CommonApi from './../commonApi';

import { convertFromKopToRub } from '../pure/unitConversions';

export const convertDataFromServer = (assignmentLimit) => ({
  ...assignmentLimit,
  sum: convertFromKopToRub(assignmentLimit.sum),
  assignmentMonths: [
  ...assignmentLimit.assignmentMonths.map((assignmentMonth) => {
    return {
      ...assignmentMonth,
      sum: convertFromKopToRub(assignmentMonth.sum)
    };
  })]

});
const assignmentLimit = new CommonApi(
  'assignmentLimit',
  'лимит закрепления',
  undefined,
  convertDataFromServer
);

export default assignmentLimit;
